'use strict';

/**
 *
 * @name: nnCategoriesList
 *
 **/

import DirectiveTemplate from './nn-categories-list.directive.html';

function NnCategoriesListDirective() {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    controller: nnCategoriesListController,
    controllerAs: 'categoriesList'
  };
}

function nnCategoriesListController(
  $rootScope,
  transObject
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */

  /*jshint validthis: true */
  // var categoriesList = this;

  ($rootScope.categoryList || [])
  .map(function(item) {

    transObject.translate(item);
    transObject.trueSlug(item);
    console.log(item,123222)
    return item;
  });

  /**
   *
   * @PUBLIC_METHODS
   *
   */

  /**
   *
   * @PRIVATE_METHODS
   *
   */

  /**
   *
   * @INIT
   *
   */
}

export default NnCategoriesListDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-categories-list/nn-categories-list.directive.js